import { render } from "./PendingPaymentRequest.vue?vue&type=template&id=2aa445b1"
import script from "./PendingPaymentRequest.vue?vue&type=script&lang=js"
export * from "./PendingPaymentRequest.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__